// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__obnIq","newExpiryDate":"styles_newExpiryDate__3-q6-","footer":"styles_footer__2vEOy"};